<template>
  <div class="product-page">
    <el-form :model="queryCondition" :inline="true" label-position="left">
      <el-form-item label="名称">
        <el-input v-model="queryCondition.ProductName" placeholder="输入名称"></el-input>
      </el-form-item>
      <el-form-item label="代码">
        <el-input v-model="queryCondition.ProductCode" placeholder="输入代码"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-radio-group v-model="queryCondition.EnableFlag">
          <el-radio :label="100">全部</el-radio>
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onBtnSearch">查询</el-button>
        <el-button type="primary" @click="onAddProduct">添加</el-button>
      </el-form-item>
    </el-form>

    <div>
      <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :current-page="queryCondition.pageindex" :page-sizes="[15,20,30,50,100]" :page-size="queryCondition.pagesize" layout="total,sizes,prev,pager,next,jumper" :total="queryCondition.count" >
      </el-pagination>
    </div>
    <el-table :data="productDatas" border style="width: 100%" v-loading="loading">
      <el-table-column prop="ProductName" label="名称" width="180"></el-table-column>
      <el-table-column prop="ProductCode" label="编码" width="180"></el-table-column>
      <el-table-column prop="TypeName" label="类别"></el-table-column>
      <el-table-column prop="UnitPrice" label="单价"></el-table-column>
      <el-table-column prop="PrivilegePrice" label="折扣价"></el-table-column>
      <el-table-column prop="EnableFlag" label="有效" width="150">
        <template slot-scope="scope">
          <el-tag :type="scope.row.EnableFlag==1?'success':'info'">{{scope.row.EnableFlag==1?'启用':'禁用'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="changeEnable(scope.row)" :type="scope.row.EnableFlag==1?'warning':'success'" size="mini">{{scope.row.EnableFlag==1?'禁用':'启用'}}</el-button>
          <el-button @click="onEditProduct(scope.row)" type="primary" size="mini">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="添加/修改品名" :visible.sync="dlgAddProduct" :close-on-click-modal="false">
      <el-form label-width="120px" :model="editProduct" :rules="rules" ref="productForm">
        <el-form-item label="名称" prop="ProductName">
          <el-input v-model="editProduct.ProductName" placeholder="输入名称"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="ProductCode">
          <el-input v-model="editProduct.ProductCode" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-cascader ref="casGoodsType" v-model="selOption" :options="goodsTypeOptions" :props="gtProps" :show-all-levels="false" @change="goodsTypeChange"></el-cascader>
        </el-form-item>
        <!--<el-form-item label="单价">
          <el-input type="number" v-model="editProduct.UnitPrice" placeholder="输入单价"></el-input>
        </el-form-item>
        <el-form-item label="优惠价格">
          <el-input type="number" v-model="editProduct.PrivilegePrice" placeholder="输入单价"></el-input>
        </el-form-item>-->
        <el-form-item label="缩略图">
          <span v-if="ImgUrl!=''" @click="onDelShortImage()"><img :src="ImgUrl" class="img"></span>
          <div class="img-uploader" @click="onShowUpload('view')"><div class="el-upload"><i class="el-icon-plus img-uploader-icon"></i></div></div>
        </el-form-item>
        <el-form-item label="轮播图">
          <span v-for="(url,idx) in RollImages" :key="idx" @click="onDelRollImage(idx)"><img :src="url" class="img"></span>
          <div class="img-uploader" @click="onShowUpload('roll')"><div class="el-upload"><i class="el-icon-plus img-uploader-icon"></i></div></div>
          <!--<el-upload class="img-uploader" action="./sys/files/upload" :show-file-list="false" :data="uploadData" :on-success="onRollImgSuccess" :before-upload="beforeRollImgUpload">
            <i class="el-icon-plus img-uploader-icon"></i>
          </el-upload>-->
        </el-form-item>
        <el-form-item label="是否整件" prop="IsWholePiece">
          <el-radio-group v-model="editProduct.IsWholePiece">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="明细图">
          <span v-for="(url,idx) in DetailImages" :key="idx" @click="onDelDetailImage(idx)"><img :src="url" class="img"></span>
          <div class="img-uploader" @click="onShowUpload('detail')"><div class="el-upload"><i class="el-icon-plus img-uploader-icon"></i></div></div>
          <!--<el-upload class="img-uploader" action="./sys/files/upload" :show-file-list="false" :data="uploadData" :on-success="onDetailImgSuccess" :before-upload="beforeDetailImgUpload">
            <i class="el-icon-plus img-uploader-icon"></i>
          </el-upload>-->
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="editProduct.Description" placeholder="输入描述"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-switch v-model="editProduct.EnableFlag" active-value="0" inactive-value="1" active-color="#dcdfe6" inactive-color="#13ce66" active-text="禁用" inactive-text="启用"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dlgAddProduct = false" :disabled="loading">取 消</el-button>
        <el-button type="primary" @click="onSaveProduct" :disabled="loading">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="上传/选择文件" :visible.sync="dlgUploadImg" :close-on-click-modal="false">
      <el-form label-width="120px" :model="editProduct" :rules="rules" ref="uploadForm">
        <el-form-item label="上传文件">
          <el-upload class="img-uploader" action="./sys/files/upload" :show-file-list="false" :data="uploadData" :on-success="onUploadImgSuccess" :before-upload="beforeImgUpload">
            <el-button type="primary">选择文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="选择图片">
          <div class="selimg-content">
            <div class="selimg-item" v-for="(imgInfo,idx) in selImgList" :key="idx" @click="onSelectImage(idx)">
              <img class="img" :src="imgInfo.view_path" />
              <span>{{imgInfo.type_name}}</span>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dlgUploadImg = false" :disabled="loading">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {searchProducts,saveProduct} from '../../api/product'
import {getRelativeImage} from '../../api/goods'
import {getGoodsTypeTree} from '../../api/goods_type'
import { isNullOrEmpty, appConfig } from '../../api/utils';

export default {
  data() {
    return {
      queryCondition: {ProductName:"", ProductCode:"", EnableFlag: 100, pageindex: 1, pagesize: 20, count: 0},
      productDatas:[],
      dlgAddProduct:false,
      editProduct: {ID:0, ProductName:"", ProductCode:"", EnableFlag: 1},
      goodsTypeOptions:[],
      loading:false,
      rules:{
        ProductName:[{ required: true, message: '请输入名称', trigger: 'blur' }]
      },
      gtProps: {
        value: 'type_code',
        label: 'label'
      },
      selOption:[],
      uploadData:{ID:0, Source:'wx', BusType:'product'},
      RollImages:[],
      DetailImages:[],
      dlgUploadImg: false,
      selImgList:[],
      selImgType:"",
      ImgUrl :""
    };
  },
  created(){
    this.onSearch();
    this.onLoadTypeTree();
  },
  methods:{
    changeEnable:function(product){
      var saveProductObj = Object.assign({}, product, {EnableFlag: product.EnableFlag == 1?0:1});
      this.loading = true
      saveProduct(saveProductObj).then(resp=>{
        this.loading = false
        if (resp.data.code == 100){
          this.$notify.success({title: '成功',message: '保存成功'})
          product.EnableFlag = saveProductObj.EnableFlag;
        }else{
          this.$notify.error({title: '失败',message: resp.data.msg})
        }
      },err=>{
        this.$notify.error({title:'修改失败',message:err.statusText})
        this.loading = false
      });
    },
    onLoadTypeTree(){
      getGoodsTypeTree().then(resp=>{
        if (resp.data.code == 100){
          this.goodsTypeOptions = resp.data.data;
        }
      },err=>{
        console.warn(err)
      });
    },
    onBtnSearch:function(){
      this.queryCondition.pageindex = 1;
      this.onSearch();
    },
    onSearch:function(){
      var that = this;
      that.loading = true
      searchProducts(this.queryCondition).then(resp=>{
        that.loading = false
        if (resp.data.code == 100){
          that.productDatas = resp.data.data.Data;
          that.queryCondition.count = resp.data.data.Count;
        }else{
          that.$notify.error({title: '失败',message: "加载数据失败：" + resp.data.msg})
        }
      },err=>{
        that.loading = false
        that.$notify.error({title:'查询失败',message:err.statusText})
      });
    },
    onAddProduct:function(){
      this.editProduct = {ID:0, ProductName:"", ProductCode:"", TypeCode:"", TypeName:"", UnitPrice:0, PrivilegePrice:0, PackQuantity:0, LeastPackQuantity:0, RollImages:"", DetailImages:"", Description:"", EnableFlag: 1};
      this.RollImages = [];
      this.DetailImages = [];
      this.dlgAddProduct = true;
      if (this.$refs['productForm'])this.$refs['productForm'].resetFields();
    },
    onEditProduct:function(product){
      this.editProduct = Object.assign({}, product);
      this.editProduct.EnableFlag = this.editProduct.EnableFlag + '';
      this.onBindTreeModel()
      if (!isNullOrEmpty(this.editProduct.ImgUrl)){
        this.ImgUrl = appConfig.file_path + this.editProduct.ImgUrl;
      }
      if (!isNullOrEmpty(this.editProduct.RollImages)){
        this.RollImages = this.editProduct.RollImages.replace(/;$/,'').split(';')
        for(var i = 0; i < this.RollImages.length; i++) this.RollImages[i] = appConfig.file_path + this.RollImages[i]
      }
      if (!isNullOrEmpty(this.editProduct.DetailImages)){
        this.DetailImages = this.editProduct.DetailImages.replace(/;$/,'').split(';')
        for(var i = 0; i < this.DetailImages.length; i++) this.DetailImages[i] = appConfig.file_path + this.DetailImages[i]
      }
      this.dlgAddProduct = true;
      if (this.$refs['productForm'])this.$refs['productForm'].resetFields();
    },
    onSaveProduct:function(){
      var isValid = false
      this.$refs['productForm'].validate((valid) => {
        isValid = valid
        return valid;
      });
      if(!isValid){
        this.$notify.info({title: '警告',message: "请按要求填写数据"})
        return
      }

      this.editProduct.EnableFlag = this.editProduct.EnableFlag * 1;
      this.editProduct.UnitPrice = this.editProduct.UnitPrice * 1;
      this.editProduct.PrivilegePrice = this.editProduct.PrivilegePrice * 1;
      this.editProduct.PackQuantity = this.editProduct.PackQuantity * 1;
      this.editProduct.LeastPackQuantity = this.editProduct.LeastPackQuantity * 1;
      if (!this.editProduct.ImgUrl && this.editProduct.RollImages && this.editProduct.RollImages.length > 0){
        var rImgs = this.editProduct.RollImages.split(";")
        if (rImgs.length > 0) {
          this.editProduct.ImgUrl = rImgs[0]
        }
      }
      this.loading = true
      saveProduct(this.editProduct).then(resp=>{
        this.loading = false
        if (resp.data.code == 100){
          this.dlgAddProduct = false;
          this.$notify.success({title: '成功',message: '保存成功'})
          if (this.editProduct.ID == 0){
            this.onSearch();
          }else{
            for(var i = 0; i < this.productDatas.length; i++){
              if (this.productDatas[i].ID == this.editProduct.ID){
                this.productDatas[i] = Object.assign(this.productDatas[i], this.editProduct);
                break;
              }
            }
          }
        }else{
          this.$notify.error({title: '失败',message: resp.data.msg})
        }
      },err=>{
        this.$notify.error({title:'保存',message:err.statusText})
        this.loading = false
      });
    },
    onBindTreeModel(){
      if (isNullOrEmpty(this.editProduct.TypeCode)){
        this.selOption = [];
      }
      function findTreeNode(nodeList, tcode){
        var codeList = []
        for(var i = 0; i < nodeList.length; i++){
          codeList.push(nodeList[i].type_code)
          if (nodeList[i].type_code == tcode) break
          if(nodeList[i].children && nodeList[i].children.length > 0){
            let cList = findTreeNode(nodeList[i].children, tcode)
            if (cList && cList.length > 0){
              codeList = codeList.concat(cList)
              break
            }
          }
          codeList.pop()
        }
        return codeList
      }
      this.selOption = findTreeNode(this.goodsTypeOptions, this.editProduct.TypeCode)
    },
    goodsTypeChange(selOp){
      let labels = this.$refs.casGoodsType.currentLabels;
      if (labels && labels.length > 0) this.editProduct.TypeName = labels[labels.length - 1]
      if (selOp && selOp.length > 0) this.editProduct.TypeCode = selOp[selOp.length - 1]
    },
    onRollImgSuccess(res, file) {
      if (res.code == 100) {
        if (this.editProduct.RollImages.length > 1 && this.editProduct.RollImages[this.editProduct.RollImages.length - 1] != ';')this.editProduct.RollImages+=";";
        this.editProduct.RollImages += res.data.FilePath + ";";
        this.RollImages.push(appConfig.file_path + res.data.FilePath)
      }
    },
    beforeRollImgUpload(file){
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
      const isLt2M = file.size / 100 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 100KB!');
      }
      return isJPG && isLt2M;
    },
    onDetailImgSuccess(res, file) {
      if (res.code == 100) {
        if (this.editProduct.DetailImages.length > 1 && this.editProduct.DetailImages[this.editProduct.DetailImages.length - 1] != ';')this.editProduct.DetailImages+=";";
        this.editProduct.DetailImages += res.data.FilePath + ";";
        this.DetailImages.push(appConfig.file_path + res.data.FilePath)
      }
    },
    beforeDetailImgUpload(file){
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
      const isLt2M = file.size / 100 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 100KB!');
      }
      return isJPG && isLt2M;
    },
    onDelShortImage(){
      if (!confirm("是否删除图片？"))return
      this.ImgUrl = "";
      this.editProduct.ImgUrl = "";
    },
    onDelRollImage(index){
      if (!confirm("是否删除图片？"))return
      this.RollImages.splice(index, 1)
      var editRollImages = this.editProduct.RollImages.split(';')
      editRollImages.splice(index, 1)
      this.editProduct.RollImages = editRollImages.join(";")
    },
    onDelDetailImage(index){
      if (!confirm("是否删除图片？"))return
      this.DetailImages.splice(index, 1)
      var editDetailImages = this.editProduct.DetailImages.split(';')
      editDetailImages.splice(index, 1)
      this.editProduct.DetailImages = editDetailImages.join(";")
    },
    onSizeChange(curSize){
      this.queryCondition.pagesize = curSize;
      this.queryCondition.pageindex = 1;
      this.onSearch();
    },
    onCurrentChange(curIndex){
      this.queryCondition.pageindex = curIndex;
      this.onSearch();
    },
    beforeImgUpload(file){
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
      var isLt2M = true;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
      }
      if (this.selImgType == "view") {
        isLt2M = file.size / 100 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 100KB!');
        }
      }
      return isJPG && isLt2M;
    },
    onUploadImgSuccess(res, file) {
      if (res.code == 100) {
        switch(this.selImgType){
          case "view":
            this.editProduct.ImgUrl = res.data.FilePath;
            this.ImgUrl = appConfig.file_path + res.data.FilePath;
            break;
          case "roll":
            if (this.editProduct.RollImages.length > 1 && this.editProduct.RollImages[this.editProduct.RollImages.length - 1] != ';')this.editProduct.RollImages+=";";
            this.editProduct.RollImages += res.data.FilePath + ";";
            this.RollImages.push(appConfig.file_path + res.data.FilePath);
            break;
          case "detail":
            if (this.editProduct.DetailImages.length > 1 && this.editProduct.DetailImages[this.editProduct.DetailImages.length - 1] != ';')this.editProduct.DetailImages+=";";
            this.editProduct.DetailImages += res.data.FilePath + ";";
            this.DetailImages.push(appConfig.file_path + res.data.FilePath)
            break;
        }
        this.dlgUploadImg = false;
      }
    },
    onSelectImage(idx){
      var imgInfo = this.selImgList[idx];
      switch(this.selImgType){
        case "view":
          this.editProduct.ImgUrl = imgInfo.img_url;
          this.ImgUrl = appConfig.file_path + imgInfo.img_url;
          break;
        case "roll":
          if (this.editProduct.RollImages.length > 1 && this.editProduct.RollImages[this.editProduct.RollImages.length - 1] != ';')this.editProduct.RollImages+=";";
          this.editProduct.RollImages += imgInfo.img_url + ";";
          this.RollImages.push(appConfig.file_path + imgInfo.img_url);
          break;
        case "detail":
          if (this.editProduct.DetailImages.length > 1 && this.editProduct.DetailImages[this.editProduct.DetailImages.length - 1] != ';')this.editProduct.DetailImages+=";";
          this.editProduct.DetailImages += imgInfo.img_url + ";";
          this.DetailImages.push(appConfig.file_path + imgInfo.img_url)
          break;
      }
      this.dlgUploadImg = false;
    },
    onShowUpload(type){
      var that = this;
      getRelativeImage("product", this.editProduct.ProductCode).then(resp=>{
        if (resp.data.code == 100){
          that.selImgList = [];
          let imgList = resp.data.data;
          let mapImgList = {};
          if (imgList && imgList.length > 0) {
            for (var i = 0; i < imgList.length; i++){
              imgList[i].view_path = appConfig.file_path + imgList[i].img_url;
              switch(imgList[i].img_type){
                case "view": imgList[i].type_name = "缩略图";break;
                case "roll": imgList[i].type_name = "轮播图";break;
                case "detail": imgList[i].type_name = "明细图";break;
              }
              mapImgList[imgList[i].img_url]=true;
            }
          }
          var rolls = that.editProduct.RollImages ? that.editProduct.RollImages.split(";") : [];
          var dets = that.editProduct.DetailImages ? that.editProduct.DetailImages.split(";") : [];
          if (that.editProduct.ImgUrl && !mapImgList[that.editProduct.ImgUrl]){
            imgList.unshift({img_url:that.editProduct.ImgUrl, type_name:"缩略图", view_path: appConfig.file_path + that.editProduct.ImgUrl, img_type:"view"})
          }
          for (var i = 0; i < rolls.length;i++){
            if (rolls[i] != "" && !mapImgList[rolls[i]]){
              imgList.unshift({img_url:rolls[i], type_name:"轮播图", view_path: appConfig.file_path + rolls[i], img_type:"roll"})
            }
          }
          for (var i = 0; i < dets.length;i++){
            if (dets[i] != "" && !mapImgList[dets[i]]){
              imgList.unshift({img_url:dets[i], type_name:"明细图", view_path: appConfig.file_path + dets[i], img_type:"detail"})
            }
          }
          that.selImgList = imgList;
        }else{
          that.$notify.error({title: '失败',message: resp.data.msg})
        }
      })
      this.selImgType = type;
      this.dlgUploadImg = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.product-page{
  .img-uploader{
    display: inline-block;
  }
  .img-uploader ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .img-uploader ::v-deep .el-upload:hover {
    border-color: #409EFF;
  }
  .img-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  .img {
    width: 40px;
    height: 40px;
    display: inline-block;
    cursor: pointer;
  }
  .selimg-content{
    display: inline-flex;
    flex-wrap: wrap;
  }
  .selimg-item{
    margin: 2px 5px;
    line-height: 20px;
  }
  .selimg-item>img{
    display: block;
  }
}
</style>
